// A label's icon can be either a FontAwesome solid icon or a plain emoji.
// Stored as a single string "fa:<name>" / "emoji:<char>" in the `icon` column,
// with a bare name (no prefix) treated as a legacy FA icon for backward compatibility.

export function parseLabelIcon(icon) {
    if (!icon) return null
    if (icon.startsWith('fa:')) return { type: 'fa', value: icon.slice(3) }
    if (icon.startsWith('emoji:')) return { type: 'emoji', value: icon.slice(6) }
    return { type: 'fa', value: icon }
}

export function encodeLabelIcon(value) {
    if (!value || !value.value) return ''
    return `${value.type}:${value.value}`
}
